import { Input, InputProps } from '@cloudscape-design/components';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { formatCurrency } from '../pages/commons/functions';
const _preserve = React.version;

interface CurrencyInputProps {
  value: number; // Removed optional '?' to ensure we have a base number
  disabled?: boolean;
  readonly?: boolean;
  width?: number;
  onChange?: (val: number) => void; // Changed to number as it's cleaner for currency
  onKeyUp?: (val: string) => void
}

export type CurrencyInputHandle = {
  focus: () => void;
};

const CurrencyInput = forwardRef<CurrencyInputHandle, CurrencyInputProps>(
  ({ value = 0, disabled = false, readonly = false, width = 200, onChange, onKeyUp }, ref) => {
    // 1. Sync the display state with the prop value
    const [displayValue, setDisplayValue] = useState<string>("");
    const [isEditing, setIsEditing] = useState<boolean>(false);

    const inputRef = useRef<InputProps.Ref>(null);
    useImperativeHandle(ref, () => ({
      focus: () => {
        inputRef.current?.focus();
      }
    }));
    // Sync internal state when the external value changes (e.g., from an API or Reset)
    useEffect(() => {
      if (!isEditing) {
        setDisplayValue(formatCurrency(value, "CLP"));
      }
    }, [value, isEditing]);

    return (
      <div
        onClick={(e) => { e.stopPropagation(); }}
        style={{ width: width }}
      >
        <Input
          ref={inputRef}
          autoComplete={false}
          value={displayValue}
          placeholder='Ingrese un monto'
          readOnly={readonly}
          disabled={disabled}
          // This helps mobile devices show only the number pad
          inputMode="numeric"
          onChange={({ detail }) => {
            // This line strictly allows ONLY numbers
            const cleanValue = detail.value.replace(/\D/g, "");

            setDisplayValue(cleanValue);
            onChange?.(parseInt(cleanValue, 10) || 0);
          }}
          onKeyUp={(e) => {
            onKeyUp?.(e.detail.key)

          }}
          onFocus={() => {
            setIsEditing(true);
            // If value is 0, clear it so user doesn't have to delete the 0
            setDisplayValue(value === 0 ? "" : value.toString());
          }}
          onBlur={() => {
            setIsEditing(false);
            setDisplayValue(formatCurrency(value, "CLP"));
          }}
        />
      </div>
    );
  }
);

export default CurrencyInput;